import { render } from "./AntifrodeDashboard.vue?vue&type=template&id=e804dbb4"
import script from "./AntifrodeDashboard.vue?vue&type=script&lang=js"
export * from "./AntifrodeDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__